import {
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaAws,
  FaHtml5,
  FaCss3Alt,
  FaPython,
  FaNpm,
} from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiJavascript,
  SiTypescript,
  SiRedux,
  SiTailwindcss,
  SiGraphql,
  SiJest,
  SiPostman,
  SiEslint,
} from "react-icons/si";
import { FiShield, FiServer } from "react-icons/fi";

export const publications = [
  {
    id: 1,
    title: "Three-Factor Authentication Using Graphical Password",
    authors: ["Viraj Yadav", "Kaushik Bhadane", "Vipul Patel", "Nisarg Kutwal"],
    venue: "International Journal of Scientific & Engineering Research (IJSER)",
    year: 2022,
    abstract:
      "This paper analyzes gaps in existing authentication methods and proposes a graphical password–based third factor to improve memorability and strengthen security.",
    // abstract:
    //   "This paper presents a novel architecture for building scalable, fault-tolerant real-time data pipelines using event-driven microservices with Kafka and Kubernetes, achieving sub-second latency at scale.",
    tags: [
      "Cybersecurity",
      "Authentication",
      "Graphical Passwords",
      "Information Security",
    ],
    doi: "https://drive.google.com/file/d/1Crq-f99z9W3BfhQtekR7nEdB9wv42lb4/view?usp=sharing",
    pdf: null,
  },
  {
    id: 2,
    title: "Three-Factor Authentication Using Image-Grid Graphical Password",
    authors: [
      "Viraj Yadav",
      "Kaushik Bhadane",
      "Vipul Patel",
      "Nisarg Kutwal",
      "Dr. Manish Giri",
    ],
    venue: "GRADIVA REVIEW JOURNAL",
    year: 2022,
    abstract:
      "This paper proposes a three-factor authentication model incorporating a graphical password as the third factor to overcome the limitations of traditional two-factor systems and strengthen overall security.",
    tags: [
      "Three-Factor Authentication",
      "Graphical Passwords",
      "Cybersecurity",
    ],
    doi: "https://drive.google.com/file/d/1Cthm8C_IZwc4LrEX4w7Y-fpOpmBvnwo7/view?usp=drivesdk",
    pdf: null,
  },
];

export const personalInfo = {
  name: "Viraj Yadav",
  title: "Full Stack Developer",
  tagline: "I build digital experiences that live on the internet.",
  description:
    "A passionate full-stack developer with expertise in the MERN stack. I love turning complex problems into simple, beautiful, and intuitive solutions. When I'm not coding, you'll find me exploring new things, wandering in nature, or playing video games.\n\nI specialize in building full-stack web applications using modern technologies. My approach is to write clean, maintainable code and design systems that scale. I'm always eager to learn and take on new challenges.",
  email: process.env.REACT_APP_EMAIL || "",
  phone: process.env.REACT_APP_PHONE || "",
  location: "India",
  resumeLink: "#",
  social: {
    github: "https://github.com/VirajLY",
    linkedin: "https://www.linkedin.com/in/virajly",
    instagram: "https://www.instagram.com/virajjj.007",
  },
};

export const skills = [
  // Languages
  { name: "JavaScript (ES6+)", icon: SiJavascript, category: "Languages" },
  { name: "TypeScript", icon: SiTypescript, category: "Languages" },
  { name: "Python", icon: FaPython, category: "Languages" },

  // Frontend
  { name: "React.js", icon: FaReact, category: "Frontend" },
  { name: "Redux", icon: SiRedux, category: "Frontend" },
  { name: "Tailwind CSS", icon: SiTailwindcss, category: "Frontend" },
  { name: "HTML5", icon: FaHtml5, category: "Frontend" },
  { name: "CSS3", icon: FaCss3Alt, category: "Frontend" },

  // Backend
  { name: "Node.js", icon: FaNodeJs, category: "Backend" },
  { name: "Express.js", icon: SiExpress, category: "Backend" },
  { name: "GraphQL", icon: SiGraphql, category: "Backend" },
  { name: "MongoDB", icon: SiMongodb, category: "Backend" },
  { name: "REST APIs", icon: FiServer, category: "Backend" },

  // DevOps & Tools
  { name: "Git", icon: FaGitAlt, category: "DevOps & Tools" },
  { name: "Jest", icon: SiJest, category: "DevOps & Tools" },
  { name: "Postman", icon: SiPostman, category: "DevOps & Tools" },
  { name: "NPM", icon: FaNpm, category: "DevOps & Tools" },
  { name: "ESLint", icon: SiEslint, category: "DevOps & Tools" },
  { name: "Snyk", icon: FiShield, category: "DevOps & Tools" },
  { name: "AWS", icon: FaAws, category: "DevOps & Tools" },
];

export const experiences = [
  {
    id: 1,
    role: "Software Engineer I",
    company: "Contentstack",
    period: "Feb 2025 – Aug 2026",
    description: [
  "Architected and built scalable full-stack enterprise integrations, enabling seamless data synchronization between third-party SaaS providers and the Contentstack core platform.",
  "Engineered bulk-fetching and caching strategies across high-throughput endpoints, cutting redundant API requests by 40–60% and optimizing resource utilization.",
  "Decreased integration response latency by 30% through concurrent request orchestration and non-blocking asynchronous execution workflows.",
  "Designed a multi-configuration credential management system and custom middleware dynamically routing GET/POST requests based on payload volume to circumvent URL constraints.",
  "Developed responsive React components for selector workflows, dynamic configuration dashboards, and complex multi-step configuration forms.",
  "Pioneered internal AI automation initiatives: built custom Claude Code skills to streamline Snyk, TruffleHog, and Gitleaks remediation, and engineered a Slack ChatOps workflow enabling on-demand execution of E2E sanity suites.",
  "Engineered and maintained a robust Playwright E2E automation framework across 30+ integrations (Trados, Wordbee, SFCC, Shopify); authored reusable test utilities reducing flakiness by ~35%."
],
    tech: [
      "React.js",
      "Node.js",
      "Express.js",
      "JavaScript",
      "TypeScript",
      "REST APIs",
      "Claude Code",
      "Playwright",
      "Snyk",
      "TruffleHog",
      "Gitleaks",
      "MySQL",
      "MongoDB",
      "Typesense"
    ],
  },
  {
    id: 2,
    role: "Associate Software Engineer",
    company: "Contentstack",
    period: "Jan 2023 – Jan 2025",
    description: [
  "Designed a robust validation engine for multi-tenant configuration workflows, eliminating configuration drift and significantly reducing deployment errors.",
  "Engineered dynamic React selector components utilizing dependent API orchestration (hierarchical categories -> products), eliminating race conditions during asynchronous data fetching.",
  "Built reusable UI component libraries (configuration modals, paginated data tables, cascading dropdowns) and refactored legacy API layers for enhanced maintainability.",
  "Partnered cross-functionally with Salesforce Commerce Cloud (SFCC) engineering teams to diagnose and resolve integration-level API contract updates and data sync anomalies."
],

    tech: [
      "React",
      "JavaScript",
      "Node.js",
      "TypeScript",
      "REST APIs",
      "State Management",
    ],
  }
];

export const projects = [
  {
    id: 1,
    title: "Three Factor Authentication",
    tagline:
      "Three factor authentication login system with graphical password as a third factor",
    description:
      "A secure Three-Factor Authentication (TFA) system with a graphical password mechanism to enhance login security, improve memorability, and strengthen protection against unauthorized access while maintaining a seamless user experience.",
    tech: ["React.js", "Node.js", "MongoDB", "Tailwind CSS", "Express.js"],
    github: "https://github.com/VirajLY/3FA-using-graphical-method",
    live: "https://3fa.virly.in",
    image: "/images/3fa.svg",
    featured: true,
  },
  {
    id: 4,
    title: "CloudNotes",
    tagline: "Markdown note-taking app",
    description:
      "A feature-rich note-taking application with markdown support, folder organization, tags, full-text search, and real-time collaboration.",
    tech: ["React", "Firebase", "Tailwind CSS", "Markdown-it"],
    github: "https://github.com/virajyadav/cloudnotes",
    live: "https://cloudnotes-demo.vercel.app",
    image: null,
    featured: false,
  },
  {
    id: 5,
    title: "WeatherPulse",
    tagline: "Weather dashboard with forecasts",
    description:
      "A beautiful weather dashboard with 7-day forecasts, interactive maps, severe weather alerts, and location-based auto-detection.",
    tech: ["React", "OpenWeather API", "Chart.js", "Geolocation API"],
    github: "https://github.com/virajyadav/weatherpulse",
    live: "https://weatherpulse-demo.vercel.app",
    image: null,
    featured: false,
  },
  {
    id: 6,
    title: "APIForge",
    tagline: "REST API testing tool",
    description:
      "A lightweight API testing tool inspired by Postman, with request history, environment variables, and collection sharing.",
    tech: ["React", "Electron", "Node.js", "SQLite"],
    github: "https://github.com/virajyadav/apiforge",
    live: null,
    image: null,
    featured: false,
  },
];
